import React from 'react';
import iconImg from '../assets/profile.webp';
import { useTransition } from '../context/TransitionContext';
import { useLanguage } from '../context/LanguageContext';
import { Calling } from 'react-iconly';
import AnimatedButton from './AnimatedButton';

const FloatingCallCard = ({ style = {}, visible = true }) => {
  const { startTransition } = useTransition();
  const { t } = useLanguage();

  return (
    <div style={{
      position: 'absolute',
      bottom: '32px',
      left: '50%',
      ...style,
      transform: style.transform
        ? `translateX(-50%) ${style.transform} ${visible ? 'translateY(0)' : 'translateY(120px)'}`
        : `translateX(-50%) ${visible ? 'translateY(0)' : 'translateY(120px)'}`,
      opacity: visible ? 1 : 0,
      transition: 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.4s cubic-bezier(0.22, 1, 0.36, 1)',
      pointerEvents: visible ? 'auto' : 'none',
      backgroundColor: 'rgba(235, 233, 223, 0.8)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      padding: '8px 8px 8px 24px',
      borderRadius: '100px',
      display: 'flex',
      alignItems: 'center',
      gap: '24px',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
      zIndex: style.zIndex || 1000,
      border: '1px solid rgba(255, 255, 255, 0.4)'
    }}>
      <span style={{
        fontFamily: 'var(--v2-font-body)',
        fontWeight: 500,
        fontSize: '14px',
        color: 'var(--v2-color-charcoal)'
      }}>
        {t('contact.bookDiscoveryCall')}
      </span>

      <AnimatedButton
        onClick={() => startTransition('/contact')}
        style={{
          border: 'none',
          padding: '10px 16px 10px 20px',
          fontFamily: 'var(--v2-font-body)',
          fontWeight: 'bold',
          fontSize: '12px',
        }}
        bgColor="var(--v2-color-charcoal)"
        textColor="var(--v2-color-white)"
        hoverBgColor="#2A2622"
        hoverTextColor="var(--v2-color-white)"
        icon={(
          <div style={{ display: 'flex', alignItems: 'center', marginLeft: '4px' }}>
            <div style={{
              width: '24px',
              height: '24px',
              borderRadius: '50%',
              overflow: 'hidden',
              border: '2px solid var(--v2-color-charcoal)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2,
              position: 'relative'
            }}>
              <img src={iconImg} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <div style={{
              width: '24px',
              height: '24px',
              borderRadius: '50%',
              backgroundColor: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '-8px',
              zIndex: 1,
              position: 'relative'
            }}>
              <Calling set="curved" size={12} color="var(--v2-color-charcoal)" />
            </div>
          </div>
        )}
      >
        {t('contact.bookCall')}
      </AnimatedButton>
    </div>
  );
};

export default FloatingCallCard;
